module.exports = __webpack_public_path__ + "media/images/crmsoftware-23d931e60edc202035a2bf3d648ed70e.png";